import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { COLORS } from 'styles/colors'

/**
 * Универсальный хук для парсинга текста и оборачивания содержимого заданных тегов в компонент TypographyBold
 */
export const useParseBoldTextByTags = () => {
	const tagList = ['b']

	return (text: string): ReactNode[] => {
		// Нормализуем текст: убираем переводы строк и лишние пробелы,
		// чтобы не было неожиданных переносов перед пунктуацией
		const normalized = text
			.replace(/\r\n|\r|\n/g, ' ')
			.replace(/\s+([.,!?;:%])/g, '$1')
			.replace(/\s{2,}/g, ' ')
			.trim()

		// Накапливаем только inline-узлы (строки и <span> для жирного)
		const children: ReactNode[] = []

		const regex = new RegExp(
			tagList.map(tag => `<${tag}>(.*?)</${tag}>`).join('|'),
			'gi',
		)

		let lastIndex = 0
		let match

		while ((match = regex.exec(normalized)) !== null) {
			const matchText = match[0]
			const beforeText = normalized.slice(lastIndex, match.index)

			if (beforeText) {
				children.push(beforeText)
			}

			const matchedTagIndex = match.findIndex(
				(m, i) => i > 0 && m !== undefined,
			)
			const boldContent = match[matchedTagIndex] || ''

			children.push(
				<Box
					key={`b-${children.length}`}
					component='span'
					sx={{ fontWeight: 600 }}
				>
					{boldContent}
				</Box>,
			)

			lastIndex = match.index + matchText.length
		}

		if (lastIndex < normalized.length) {
			children.push(normalized.slice(lastIndex))
		}

		// Возвращаем один общий inline-обёртчик, чтобы браузер не вставлял переносы между отдельными Typography
		return [
			<Typography
				key='text'
				component='span'
				sx={{
					display: 'inline',
					whiteSpace: 'normal',
					m: 0,
					p: 0,
					fontWeight: 400,
					fontSize: '14px',
					lineHeight: '17px',
					color: COLORS.black,
				}}
			>
				{children}
			</Typography>,
		]
	}
}
